/**
 * Subjects (service registry) event types for real-time notifications and durable event recording.
 */
export enum SubjectsEventType {
  SERVICE_REGISTERED = 'subjects:service-registered',
  SERVICE_DEREGISTERED = 'subjects:service-deregistered',
  EPHEMERAL_REGISTERED = 'subjects:ephemeral-registered',
  EPHEMERAL_RELEASED = 'subjects:ephemeral-released',
}

/**
 * Pub/sub channel for subjects events.
 */
export const SUBJECTS_EVENTS_CHANNEL = 'subjects:events';